import { render, staticRenderFns } from "./ScrollyBar.vue?vue&type=template&id=2553c7c3"
import script from "./ScrollyBar.vue?vue&type=script&lang=js"
export * from "./ScrollyBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports